import React, { Component } from 'react';
import { TogglerBody, TogglerIndicator } from './style';

export class Toggler extends Component {
    state = {
        togglerState: this.props.state || false,
    };

    toggleState = () => {
        const { onChange, disabled } = this.props;

        if (disabled) return;

        this.setState({ togglerState: !this.state.togglerState }, () => {
            onChange(this.state.togglerState);
        });
    };

    render() {
        const {
            state: { togglerState },
            toggleState,
        } = this;
        return (
            <TogglerBody onClick={toggleState} state={togglerState}>
                <TogglerIndicator />
            </TogglerBody>
        );
    }
}

export default Toggler;



// WEBPACK FOOTER //
// ./src/UI/Components/Toggler/index.js